import { render, staticRenderFns } from "./ClientDetails.vue?vue&type=template&id=0d50215e&scoped=true"
import script from "./ClientDetails.vue?vue&type=script&lang=js"
export * from "./ClientDetails.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0d50215e",
  null
  
)

export default component.exports